export default __webpack_public_path__ + "static/media/frownyGirl.57f8c116.jpg";